// extracted by mini-css-extract-plugin
module.exports = {"questions":"components_questions__KEpb9","question_modal":"components_question_modal__SKZBW","rules_modal":"components_rules_modal__ik2rn"};